import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'

// eslint-disable-next-line
import { required, email, confirmed, min, max, regex } from 'vee-validate/dist/rules'

extend('required', required)
extend('email', email)
extend('confirmed', confirmed)
extend('min', min)
extend('max', max)
extend('regex', regex)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

/**
 * 開発・レビュー 注意事項
 *
 * vee-validateを利用する場合、各画面で利用ルールのmessageを定義(extend)してください。
 * (デフォルトのメッセージは利用しない。必ず画面毎にextendする。)
 * また、message以外のextendは行わないようにしてください。
 *
 * vee-validateでextendした内容は、他の画面でも引き続き影響が残るためです。
 */
